import isNode from '../../modules/ajio-util/isNode.js';
import { getFeatureVariant } from '../../refresh/organism/ABFeature/Feature';
import { clearCookie } from '../../utils/clearStorage';

function isValidJSON(jsonString) {
  try {
    const parsedValue = JSON.parse(jsonString);
    return typeof parsedValue === 'object' && parsedValue !== null;
  } catch (e) {
    return false;
  }
}

export function createCookie(name, value, days) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toGMTString()}`;
  }
  let { href = '' } = location;
  let domain = '';
  if (href.toLowerCase().includes('ajio')) {
    domain = 'domain=.ajio.com';
  }
  if (href.toLowerCase().includes('ajio.jio')) {
    domain = 'domain=.jio.com';
  }
  if (href.toLowerCase().includes('ajio.ril')) {
    domain = 'domain=.ril.com';
  }
  // Add Secure flag for all environments except localhost
  const isLocalhost =
    typeof location !== 'undefined' &&
    (location.hostname === 'localhost' || location.hostname === '127.0.0.1');
  const secureFlag = isLocalhost ? '' : '; Secure';
  // console.log('Values of cookies set from client side -> ', `${name}=${value}${expires}; path=/;${domain}${secureFlag}`)
  document.cookie = `${name}=${value}${expires}; path=/;${domain}${secureFlag}`;
  // domain=.ajio.com"
  console.groupEnd();
}

export function createCookieForHours(name, value, hours) {
  let expires = '';
  if (hours) {
    const date = new Date();
    date.setTime(date.getTime() + hours * 60 * 60 * 1000);
    expires = `; expires=${date.toGMTString()}`;
  }
  let { href = '' } = location;
  let domain = '';
  if (href.toLowerCase().includes('ajio')) {
    domain = 'domain=.ajio.com';
  }
  if (href.toLowerCase().includes('ajio.jio')) {
    domain = 'domain=.jio.com';
  }
  if (href.toLowerCase().includes('ajio.ril')) {
    domain = 'domain=.ril.com';
  }
  // Add Secure flag for all environments except localhost
  const isLocalhost =
    typeof location !== 'undefined' &&
    (location.hostname === 'localhost' || location.hostname === '127.0.0.1');
  const secureFlag = isLocalhost ? '' : '; Secure';
  // console.log('Values of cookies set from client side -> ', `${name}=${value}${expires}; path=/;${domain}${secureFlag}`)
  document.cookie = `${name}=${value}${expires}; path=/;${domain}${secureFlag}`;
  // domain=.ajio.com"
  console.groupEnd();
}

export function readCookie(name) {
  var nameEQ = `${name}=`;
  let cachedCookies = null;
  if (!isNode() && document) {
    if(!cachedCookies){
      cachedCookies = document.cookie; // Cache the cookie string
    }
    var ca = cachedCookies.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}
export function ManageCookies() {
  this.setItem = (key, val) => {
    const d = new Date();
    d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000); // Cookie expiration after 1 year
    let expires = `expires=${d.toUTCString()}`;
    // Add Secure flag for all environments except localhost
    const isLocalhost =
      typeof location !== 'undefined' &&
      (location.hostname === 'localhost' || location.hostname === '127.0.0.1');
    const secureFlag = isLocalhost ? '' : '; Secure';
    document.cookie = `${key} = ${val}; ${expires}; path=/${secureFlag}`;
  };
  this.addItem = (key, val) => {
    const storeValue = this.getItem(key);
    const storedArr = storeValue ? [...storeValue.split(','), val] : [val];
    const d = new Date();
    d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000); // Cookie expiration after 1 year
    let expires = `expires=${d.toUTCString()}`;
    const uniqueValue = Array.from(new Set(storedArr));
    this.setItem(key, uniqueValue);
  };
  this.getItem = cookieName => {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(`${cookieName}=`)) {
        return cookie.substring(cookieName.length + 1, cookie.length);
      }
    }
    return '';
  };
  this.removeItem = (key, val) => {
    const arr = (this.getItem(key) || '').split(',');
    const filteredArr = arr.filter(arrVal => arrVal !== val);
    this.setItem(key, filteredArr);
  };
}

export function readCohortValueCookie(cohortValues, storeval, serviceName = 'cms', enableUniversalCohortFlow=false) {
  try {
    let tempData;
    if (!isNode() && document) {
      tempData = readCookie(cohortValues);
    }
    if (!tempData || !isValidJSON(tempData)) return null;

    let cohortValue = '';
    const cohortData = JSON.parse(tempData);
    if(enableUniversalCohortFlow) {
      cohortValue = cohortData?.[serviceName]?.cohorts || '';
      return cohortValue;
    }
    const newStoreval = storeval ? `${storeval}_v1` : 'rilfnl_v1';

    if (cohortData && Array.isArray(cohortData)) {
      cohortData.forEach(element => {
        const { key, value } = element;
        if (!storeval && key === 'rilfnl_v1') {
          cohortValue = value;
        } else if (newStoreval && newStoreval === key) {
          cohortValue = value;
        }
      });
    } else {
      cohortValue = cohortData?.[newStoreval]?.[serviceName]?.cohorts || '';
    }

    return cohortValue;
  } catch (error) {
    console.error("❌ Error in readCohortValueCookie:", error);
    return '';
  }
}

export function eraseCookie(name) {
  createCookie(name, '', -1);
}

export function getCookie(name) {
  if (isNode()) return '';

  var value = `; ${document.cookie}`;
  var parts = value.split(`; ${name}=`);
  if (parts.length == 2)
    return parts
      .pop()
      .split(';')
      .shift();
}

export function readClusterCookie(clusterCookie, storeval) {
  let temp = clusterCookie;
  if (!isNode() && document) {
    temp = readCookie(clusterCookie);
  }
  if (!temp || !temp.includes('-')) {
    return;
  }
  const data = temp.split('-');
  let cluster = data[0];
  const cohortValues = data.slice(1);
  cohortValues.forEach(value => {
    if (value) {
      const storeCohort = value.split('=');
      let newStoreval = (storeval && `${storeval}_v1`) || '';

      if (!storeval && (storeCohort[0] === 'rilfnl' || storeCohort[0] === 'rilfnl_v1')) {
        cluster = storeCohort[1];
      }

      if (storeval && (storeval === storeCohort[0] || newStoreval === storeCohort[0])) {
        cluster = storeCohort[1];
      }
    }
  });
  return cluster;
}

export function updateClusterCookie(storeval, flag) {
  if (isNode() || !flag) {
    return;
  }
  if (getFeatureVariant('cohortValues') !== '0') {
    const data = JSON.parse(sessionStorage.getItem('customerTypeData')) || '';
    if (data) {
      const tempCookie = (readCookie('cluster') || '').split('-');
      const { userCohortValue = [] } = data;
      const store = storeval || 'rilfnl';
      const clusterObj = userCohortValue.find(item => item.key === store) || {};
      const clusterValue = clusterObj.value || '';
      if (tempCookie[0] !== clusterValue) {
        let cluster = '';
        let alldatacluster = '';
        userCohortValue.forEach(element => {
          const { key, value } = element;
          // converting object to string to update cookie based on sis
          alldatacluster = `${alldatacluster}-${key}=${value}`;
          if (!storeval && key === 'rilfnl') {
            cluster = value;
          }
          if (storeval && storeval === key) {
            cluster = value;
          }
        });
        // appending cluster to make cookie unique so that varnish can cache separately
        alldatacluster = `${cluster}${alldatacluster}`;
        createCookie('cluster', alldatacluster, 1);
      }
    }
  }
}

export function updatePlpAdsCookie() {
  // As discussed by default firebase flag will be OFF
  // so ads will drive through 'plpAds' cookie if its set then will send saas true
  // if we enable firebase flag to ON , experiment has to be ended as it is not doing any thing
  if (getFeatureVariant('jioAdsOnPlp') !== '0') {
    createCookie('plpAds', 'true', 1);
  } else {
    clearCookie('plpAds');
  }
}

export function updateSlpAdsCookie() {
  // will implement same logic as we implemented in updatePlpAdsCookie function, by default firebase flag will be OFF
  // so ads will drive through 'slpAds' cookie if its set then will send saas true
  // if we enable firebase flag to ON , experiment has to be ended as it is not doing any thing
  if (getFeatureVariant('jioAdsOnSlp') !== '0') {
    createCookie('slpAds', 'true', 1);
  } else {
    clearCookie('slpAds');
  }
}

export function checkEarlyAccessUser(storeName = '', serviceName = 'cms') {
  let storeval = storeName && storeName.toLowerCase() == 'ajio' ? '' : storeName;
  const value = readCohortValueCookie('userCohortValues', storeval, serviceName);
  return !!(value && value.indexOf('earlyaccess') >= 0);
}

export function readCohortValueCookieAtNode(
  cookieValue,
  storeval,
  serviceName = 'cms',
  enableUniversalCohortFlow = false
) {
  try {
    if (!cookieValue || !isValidJSON(cookieValue)) return null;

    let cohortValue = '';
    const cohortData = JSON.parse(cookieValue);

    // Universal cohort flow
    if (enableUniversalCohortFlow) {
      return cohortData?.[serviceName]?.cohorts || '';
    }

    const newStoreval = storeval ? `${storeval}_v1` : 'rilfnl_v1';

    // Legacy array structure
    if (Array.isArray(cohortData)) {
      cohortData.forEach(item => {
        const { key, value } = item || {};
        if (!storeval && key === 'rilfnl_v1') {
          cohortValue = value;
        } else if (newStoreval === key) {
          cohortValue = value;
        }
      });
      return cohortValue;
    }

    // Object-based structure
    return cohortData?.[newStoreval]?.[serviceName]?.cohorts || '';
  } catch (error) {
    console.error('Error in readCohortValueCookie:', error);
    return '';
  }
}
